import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Blogolicious envy",
  "description": "",
  "published": "2008-01-07T00:00:00.000Z",
  "redirect_from": ["/blog/blogolicious-envy/swizec/136"],
  "categories": "food for thought, intrigues",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Not long ago my bird, as some have taken to labeling her, mentioned that she is envious of my writing vigour and style, of how my words seem to simply flow without effort. She got specifically bummed after I mentioned that these blog posts are posted as-is. No editing, no great thought, just a flow of rambling as it jumps out of my throbbing brain.`}</p>
    <p>{`But there's really nothing to it. This is how I think, this is how my brain works. Words have always been a trivial matter to me ... actually since as long as I can remember I could go into long yappings over anything. I was very opinionated even as a young child and once I discovered the written word nothing could really stop me. The first time I tried writing a book I was around ten and have been trying, without success, to write a book ever since.`}</p>
    <p>{`I guess it's merely a matter of practice. The more you think, talk, write, the better you are at words. As soon as you become too aware of what you're saying, of what you're writing, the words become forced, even raped and they drag through the receiver's mind like barbbed wire. Of course this is not to be confused with properly polished writing that comes from a third rendition of that first jumble of words. But that's reserved only for things that are art and need to be good.`}</p>
    <p>{`To finish this particular ramble off, I'd just like to point out that at times I am quite jealous of `}<a parentName="p" {...{
        "href": "http://www.vijavaja.com/enter/cenca/dnevnik_podrob.php?ID=57451"
      }}>{`the girl's own blog`}</a>{` because, sometimes, it tickles my spider senses and sends a shiver of depth and emotion through me. Sometimes ... that blog is just pure emotion and it is `}<em parentName="p">{`always`}</em>{` an elatic read.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      